module.exports = new __parcel__URL__("Sass.9add5eb9.svg").toString();